import { Component, OnInit } from '@angular/core';
import { MessageService } from 'src/app/services/message.service';
import { SubmenuService } from '../../submenu/submenu.service';
import { NavigationNodeRuleService } from 'src/app/services/navigation/navigation-node-rule.service';
import { NavigationNodeService } from 'src/app/services/navigation/navigation-node.service';

@Component({
  selector: 'app-navigation-node-list',
  templateUrl: './navigation-node-list.component.html',
  styleUrls: ['./navigation-node-list.component.less']
})
export class NavigationNodeListComponent implements OnInit {

  page:number = 1;
  pageSize:number = 25;
  queryString= "";
  listData:any[];

  constructor(public navigationNode:NavigationNodeService, public messageService:MessageService, public submenuService:SubmenuService)
  { 

  }

  ngOnInit(): void {
    
    this.loadData();
  }

  ngAfterViewChecked(){
    this.submenuService.showRecordList("/navigation/nodes");    
  }

  loadData(){
    this.messageService.showLoading();
    this.navigationNode.loadPage(this.page, this.pageSize, this.queryString).subscribe(
      (data:any) => {
        this.listData = data;
        this.messageService.hideLoading();
    },
    
    err => {
      this.messageService.hideLoading();
      this.messageService.showMessage(err.message, "error");
      console.log(err);
    });
  }

}
